import request from '@/utils/request'

export interface CouponTemplate {
  id?: number
  name: string
  type: number
  amount: number
  minAmount: number
  validFrom?: string | null
  validTo?: string | null
  storeId?: number | null
  status?: number
}

export const getCouponList = (params: any) => {
  return request({
    url: '/coupon/list',
    method: 'get',
    params
  })
}

export const createCoupon = (data: CouponTemplate) => {
  return request({
    url: '/coupon',
    method: 'post',
    data
  })
}

export const updateCoupon = (data: CouponTemplate) => {
  return request({
    url: '/coupon',
    method: 'put',
    data
  })
}

export const deleteCoupon = (id: number) => {
  return request({
    url: `/coupon/${id}`,
    method: 'delete'
  })
}
